var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"lang":_vm.$i18n.locale}})
}
var staticRenderFns = []

export { render, staticRenderFns }